<div [innerHTML]="content ? (content.html | sanitize) : ''" ></div>
